import { render, staticRenderFns } from "./idea_1.vue?vue&type=template&id=85cceada&scoped=true&"
var script = {}
import style0 from "./idea_1.vue?vue&type=style&index=0&id=85cceada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cceada",
  null
  
)

export default component.exports